





































































import { Component, Prop, Vue } from 'vue-property-decorator';

import AbstractAddItem_Step2 from '../AbstractAddItem-Step2.vue';
import ErrorWrappedTextInput from '@/components/form-elements/ErrorWrappedTextInput.vue';
import { ProductItem } from '@/models/items/product-item-model';

@Component({
  components: { ErrorWrappedTextInput }
})
export default class AddProductItem_Step2 extends AbstractAddItem_Step2 {
  created() {
    // super.created();
    // 

    if (this.lastStepData.query) {
      const parts = this.lastStepData.query.split(' ');
      (this.item as ProductItem).brandMake = parts[0];
      if (parts.length > 1) {
        (this.item as ProductItem).model = parts.slice(1).join(' ');
      }
    }
  }
}
